/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetListBillPaymentResponse,
  UtxBillPaymentFindBillPaymentParams,
  CreateBillPaymentResponse,
  CreateBillPaymentRequest,
  CancelBillPaymentResponse,
  CreateBillPaymentDocumentResponse,
  CreateBillPaymentDocumentRequest,
  GetPendingFundingAmountResponse
} from './schema'



export const utxBillPaymentFindBillPayment = (
    params: UtxBillPaymentFindBillPaymentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetListBillPaymentResponse>> => {
    return axios.get(
      `/bill-payment`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBillPaymentFindBillPaymentQueryKey = (params: UtxBillPaymentFindBillPaymentParams,) => [`/bill-payment`, ...(params ? [params]: [])];

    
export type UtxBillPaymentFindBillPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentFindBillPayment>>>
export type UtxBillPaymentFindBillPaymentQueryError = AxiosError<unknown>

export const useUtxBillPaymentFindBillPayment = <TData = Awaited<ReturnType<typeof utxBillPaymentFindBillPayment>>, TError = AxiosError<unknown>>(
 params: UtxBillPaymentFindBillPaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBillPaymentFindBillPayment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBillPaymentFindBillPaymentQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBillPaymentFindBillPayment>>> = ({ signal }) => utxBillPaymentFindBillPayment(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBillPaymentFindBillPayment>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBillPaymentCreateBillPayment = (
    createBillPaymentRequest: CreateBillPaymentRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateBillPaymentResponse>> => {
    return axios.post(
      `/bill-payment`,
      createBillPaymentRequest,options
    );
  }



    export type UtxBillPaymentCreateBillPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentCreateBillPayment>>>
    export type UtxBillPaymentCreateBillPaymentMutationBody = CreateBillPaymentRequest
    export type UtxBillPaymentCreateBillPaymentMutationError = AxiosError<unknown>

    export const useUtxBillPaymentCreateBillPayment = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBillPaymentCreateBillPayment>>, TError,{data: CreateBillPaymentRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBillPaymentCreateBillPayment>>, {data: CreateBillPaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBillPaymentCreateBillPayment(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBillPaymentCreateBillPayment>>, TError, {data: CreateBillPaymentRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBillPaymentCancelBillPayment = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CancelBillPaymentResponse>> => {
    return axios.post(
      `/bill-payment/${id}/cancel`,undefined,options
    );
  }



    export type UtxBillPaymentCancelBillPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentCancelBillPayment>>>
    
    export type UtxBillPaymentCancelBillPaymentMutationError = AxiosError<unknown>

    export const useUtxBillPaymentCancelBillPayment = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBillPaymentCancelBillPayment>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBillPaymentCancelBillPayment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  utxBillPaymentCancelBillPayment(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBillPaymentCancelBillPayment>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBillPaymentGetEmailInstruction = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `/bill-payment/email-instruction`,options
    );
  }


export const getUtxBillPaymentGetEmailInstructionQueryKey = () => [`/bill-payment/email-instruction`];

    
export type UtxBillPaymentGetEmailInstructionQueryResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentGetEmailInstruction>>>
export type UtxBillPaymentGetEmailInstructionQueryError = AxiosError<unknown>

export const useUtxBillPaymentGetEmailInstruction = <TData = Awaited<ReturnType<typeof utxBillPaymentGetEmailInstruction>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBillPaymentGetEmailInstruction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBillPaymentGetEmailInstructionQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBillPaymentGetEmailInstruction>>> = ({ signal }) => utxBillPaymentGetEmailInstruction({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBillPaymentGetEmailInstruction>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBillPaymentCreateBillPaymentDocument = (
    createBillPaymentDocumentRequest: CreateBillPaymentDocumentRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateBillPaymentDocumentResponse>> => {
    return axios.post(
      `/bill-payment/create-document`,
      createBillPaymentDocumentRequest,options
    );
  }



    export type UtxBillPaymentCreateBillPaymentDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentCreateBillPaymentDocument>>>
    export type UtxBillPaymentCreateBillPaymentDocumentMutationBody = CreateBillPaymentDocumentRequest
    export type UtxBillPaymentCreateBillPaymentDocumentMutationError = AxiosError<unknown>

    export const useUtxBillPaymentCreateBillPaymentDocument = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBillPaymentCreateBillPaymentDocument>>, TError,{data: CreateBillPaymentDocumentRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBillPaymentCreateBillPaymentDocument>>, {data: CreateBillPaymentDocumentRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBillPaymentCreateBillPaymentDocument(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBillPaymentCreateBillPaymentDocument>>, TError, {data: CreateBillPaymentDocumentRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBillPaymentGetPendingFundingAmount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPendingFundingAmountResponse>> => {
    return axios.get(
      `/bill-payment/pending-funding-amount`,options
    );
  }


export const getUtxBillPaymentGetPendingFundingAmountQueryKey = () => [`/bill-payment/pending-funding-amount`];

    
export type UtxBillPaymentGetPendingFundingAmountQueryResult = NonNullable<Awaited<ReturnType<typeof utxBillPaymentGetPendingFundingAmount>>>
export type UtxBillPaymentGetPendingFundingAmountQueryError = AxiosError<unknown>

export const useUtxBillPaymentGetPendingFundingAmount = <TData = Awaited<ReturnType<typeof utxBillPaymentGetPendingFundingAmount>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBillPaymentGetPendingFundingAmount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBillPaymentGetPendingFundingAmountQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBillPaymentGetPendingFundingAmount>>> = ({ signal }) => utxBillPaymentGetPendingFundingAmount({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBillPaymentGetPendingFundingAmount>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

